import { ProgressCircle } from '@adobe/react-spectrum';

interface LoadingProps {
  className?: string;
  size?: 'S' | 'M' | 'L';
}

export const Loading = (props: LoadingProps) => {
  const { className, size = 'M' } = props;
  return (
    <ProgressCircle
      aria-label="Loading…"
      isIndeterminate
      size={size}
      UNSAFE_className={className}
    />
  );
};
